import { ReactNode, useState } from 'react';

import { ConfirmAction } from '@hooks/useConfirmBase/types';

import useConfirmBase from '../useConfirmBase';

import ConfirmDialog from './ConfirmDialog';

const useConfirmDialog = (loading?: boolean) => {
  const { request, actions, prompt, open, onCancel } = useConfirmBase(loading);

  const [dialogTitle, setDialogTitle] = useState<string>();

  const handleRequest = (title: string, prompt: ReactNode, action?: ConfirmAction) => {
    setDialogTitle(title);
    return request(prompt, action);
  };

  return {
    request: handleRequest,
    dialog: (
      <ConfirmDialog
        dialogTitle={dialogTitle}
        loading={loading}
        onCancel={onCancel}
        open={open}
        prompt={prompt}
      >
        {actions}
      </ConfirmDialog>
    ),
  };
};

export default useConfirmDialog;
